/* First Light Astronomy — Clients logo marquee
   - Auto-scrolls horizontally (~90 px/sec)
   - Pauses on hover and during drag
   - Pointer drag works for mouse, touch, pen
   - Respects prefers-reduced-motion (auto-scroll off, drag still works)
   - Idempotent: safe to call multiple times (theme editor re-renders) */
(function () {
  function init(root) {
    if (!root || root.dataset.flaMarqueeReady === '1') return;
    var marquee = root.querySelector('.fla-clients__marquee');
    var grid = root.querySelector('.fla-clients__grid');
    if (!marquee || !grid) return;
    root.dataset.flaMarqueeReady = '1';

    // Duplicate cells once for seamless infinite loop
    Array.from(grid.children).forEach(function (cell) {
      var clone = cell.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      grid.appendChild(clone);
    });

    var SPEED = parseFloat(root.dataset.flaSpeed) || 90;
    var position = 0;
    var loopWidth = 0;
    var isHovered = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartPos = 0;
    var lastFrame = 0;
    var reducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

    var measureScheduled = false;
    // Schedule the scrollWidth read in a rAF so it never runs synchronously right
    // after DOM writes (cloning cells) — avoids forced reflow / layout thrash.
    function measure() { measureScheduled = false; loopWidth = grid.scrollWidth / 2; }
    function scheduleMeasure() { if (measureScheduled) return; measureScheduled = true; requestAnimationFrame(measure); }
    function apply() { grid.style.transform = 'translate3d(' + position + 'px,0,0)'; }

    function tick(now) {
      if (!lastFrame) lastFrame = now;
      var dt = (now - lastFrame) / 1000;
      lastFrame = now;
      if (!isHovered && !isDragging && !reducedMotionMQ.matches) {
        position -= SPEED * dt;
      }
      if (loopWidth > 0) {
        while (position <= -loopWidth) position += loopWidth;
        while (position > 0) position -= loopWidth;
      }
      apply();
      requestAnimationFrame(tick);
    }

    scheduleMeasure();
    window.addEventListener('load', scheduleMeasure);
    window.addEventListener('resize', scheduleMeasure);
    grid.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', scheduleMeasure);
    });

    marquee.addEventListener('mouseenter', function () { isHovered = true; });
    marquee.addEventListener('mouseleave', function () { isHovered = false; });

    marquee.addEventListener('pointerdown', function (e) {
      isDragging = true;
      dragStartX = e.clientX;
      dragStartPos = position;
      marquee.classList.add('is-dragging');
      try { marquee.setPointerCapture(e.pointerId); } catch (_) {}
    });
    marquee.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      position = dragStartPos + (e.clientX - dragStartX);
    });
    function endDrag(e) {
      if (!isDragging) return;
      isDragging = false;
      marquee.classList.remove('is-dragging');
      try { marquee.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    marquee.addEventListener('pointerup', endDrag);
    marquee.addEventListener('pointercancel', endDrag);

    requestAnimationFrame(tick);
  }

  function bootAll() {
    document.querySelectorAll('[data-fla-clients]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  // Re-init when Shopify theme editor re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector('[data-fla-clients]') || (e.target.matches && e.target.matches('[data-fla-clients]') ? e.target : null);
    if (node) init(node);
  });
})();
